import axios from 'src/utils/axios';

export const UPDATE_USER = '@productionOrder/update-user';
export const UPDATE_CODEOP = '@productionOrder/update-codeop';
export const UPDATE_COUPON = '@productionOrder/update-talao';
export const UPDATE_QUANTITY = '@productionOrder/update-quantity';
export const UPDATE_DETAIL = '@productionOrder/update-detail';
export const UPDATE_ALL_QUANTITY = '@productionOrder/update-all-quantity';
export const UPDATE_TAGS_SELECT = '@productionOrder/update-tags-select';
export const ADD_INFO_TABLE = '@productionOrder/add-info-table';
export const UPDATE_QUANTITY_SELECT = '@productionOrder/update_quantity_select';
export const CANCEL = '@productionOrder/cancel';
export const VALIDATION_FUNCTION = '@productionOrder/validation-function';
export const SELECT_PRODUCTION_ORDER =
  '@productionOrder/select-production-order';
export const SET_OP_LIST = '@productionOrder/set-op-list';
export const GENERAL_INFORMATION = '@productionOrder/setGeneralInformation';
export const UPDATE_EXPIRATION = '@productionOrder/setExpiration';
export const UPDATE_PARAMETERS = '@productionOrder/updateParameters';
export const UPDATE_PARAMETERS_CONFIG =
  '@productionOrder/updateParametersConfig';
export const UPDATE_DEMANDS = '@productionOrder/updateDemands';
export const UPDATE_STEP = '@productionOrder/updateStep';
export const UPDATE_STEP_LIMIT = '@productionOrder/updateStepLimit';
export const UPDATE_RESOURCES = '@productionOrder/updateResources';
export const DELETE_RESOURCE = '@productionOrder/deleteResource';
export const DEMANDS_COMPLETE = '@productionOrder/demandsComplete';
export const UPDATE_INITIAL_STEP = '@productionOrder/updateInitialStep';
export const SET_FABRICATION_DETAILS = '@productionOrder/setFabricationDetails';
export const UPDATE_FULFILLED = '@productionOrder/updateFulfilled';

export function updateUser(user) {
  return {
    type: UPDATE_USER,
    payload: user,
  };
}

export function updateCodeOp(codeOp) {
  return {
    type: UPDATE_CODEOP,
    payload: codeOp,
  };
}

export function updateCoupon(coupon) {
  return {
    type: UPDATE_COUPON,
    payload: coupon,
  };
}

export function updateQuantity(key, quantity) {
  return {
    type: UPDATE_QUANTITY,
    payload: {
      key,
      quantity,
    },
  };
}

export function updateDetail(key, value) {
  return {
    type: UPDATE_DETAIL,
    payload: {
      key,
      value,
    },
  };
}

export function updateAllQuantities(quantity) {
  return {
    type: UPDATE_ALL_QUANTITY,
    payload: quantity,
  };
}

export function tagsSelect(value) {
  return {
    type: UPDATE_TAGS_SELECT,
    payload: value,
  };
}

export function quantitySelectValue(quantity) {
  return {
    type: UPDATE_QUANTITY_SELECT,
    payload: quantity,
  };
}

export function addInfoTable(quantities, total, option) {
  return {
    type: ADD_INFO_TABLE,
    payload: { quantities, total, option },
  };
}

export function cancel() {
  return {
    type: CANCEL,
    payload: null,
  };
}

export function setValidationFunction(validation) {
  return {
    type: VALIDATION_FUNCTION,
    payload: validation,
  };
}

export function selectProductionOrder(
  productionOrderCode,
  coupon,
  sequence,
  liberationCode,
  total,
  manufacturedQuantity,
  materialCode,
  readBy
) {
  return {
    type: SELECT_PRODUCTION_ORDER,
    payload: {
      productionOrderCode,
      coupon,
      sequence,
      liberationCode,
      total,
      manufacturedQuantity,
      materialCode,
      readBy,
    },
  };
}

export function setOpList(productionOrder) {
  return {
    type: SET_OP_LIST,
    payload: productionOrder,
  };
}

export function setGeneralInformation(
  materialDescription,
  unitMeasurement,
  materialCode,
  initialDate,
  finalDate,
  batch,
  fabricationDate,
  validDate,
  hasQuiz,
  validBatch,
  initialFinalReading,
  materialImage,
  changeFabricationDate,
  unitMeasurementInteger,
  unitMeasurementDecimal,
  fulfilledFound,
  fulfilledMessage
) {
  return {
    type: GENERAL_INFORMATION,
    payload: {
      materialDescription,
      unitMeasurement,
      materialCode,
      initialDate,
      finalDate,
      batch,
      fabricationDate,
      validDate,
      hasQuiz,
      validBatch,
      initialFinalReading,
      materialImage,
      changeFabricationDate,
      unitMeasurementInteger,
      unitMeasurementDecimal,
      fulfilledFound,
      fulfilledMessage,
    },
  };
}

export function updateExpirationDate(
  productionOrderCode,
  coupon,
  fabricationDate
) {
  const date = fabricationDate.format('YYYY-MM-DD');

  const request = axios.get(
    `/suprimentos/pc/ordemproducao/calculadatavalidade?codigoOrdemProducao=${productionOrderCode}&numeroTalao=${coupon}&dataFabricacaoInput=${date}`
  );

  return dispatch => {
    request.then(response => {
      dispatch({
        type: UPDATE_EXPIRATION,
        payload: response.data,
      });
    });
  };
}

export function getAllResources(op, coupon) {
  const request = axios.get(
    `suprimentos/pc/recursoproducao/recursosordemproducao?codigoOrdemProducao=${op}&numeroTalao=${coupon}&$select=TipoProducao,CodigoUnidadeMedida,QuantidadeRecursosUtilizados,QuantidadeProducao,CodigoPCPRecurso,CodigoOcorrencia,DataInicialUtilizacao,DataFinalUtilizacao,HoraFinalUtilizacao,DataFinalMovimentoProducao,HoraFinalMovimentoProducao,CodigoRecurso,Liberacao,HoraInicialUtilizacao,HorasTotaisUtilizacao,CodigoOperador,Sequencia,Codigo&$expand=Recurso($select=Codigo,Descricao),`
  );

  return dispatch => {
    request.then(response => {
      dispatch({
        type: UPDATE_RESOURCES,
        payload: response.data,
      });
    });
  };
}

export function deleteResource(index) {
  return dispatch => {
    dispatch({
      type: DELETE_RESOURCE,
      payload: index,
    });
  };
}

export function updateParameters(parameter, name, value) {
  return {
    type: UPDATE_PARAMETERS,
    payload: {
      parameter,
      name,
      value,
    },
  };
}

export function updateParametersConfig(
  operationType,
  storageCenter,
  productionOccurrences,
  options
) {
  return {
    type: UPDATE_PARAMETERS_CONFIG,
    payload: {
      operationType,
      storageCenter,
      productionOccurrences,
      options,
    },
  };
}

export function updateDemands(opId, coupon, type, steps) {
  const request = axios.get(
    `/suprimentos/pc/movimentoproducaoauxiliar/dadosdemandaauxiliar?codigoOrdemProducao=${opId}&talao=${coupon}&TipoCodigo=${type}`
  );

  const produced = steps.find(step => step.type === 'F' && step.quantity > 0);

  return dispatch => {
    request
      .then(() => {
        dispatch({
          type: UPDATE_DEMANDS,
          payload: {
            produced: produced ? { teste: 'teste' } : {},
            defect: {},
            lost: {},
          },
        });
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function updateStep(nextStep) {
  return {
    type: UPDATE_STEP,
    payload: nextStep,
  };
}

export function updateStepLimit(limit) {
  return {
    type: UPDATE_STEP_LIMIT,
    payload: limit,
  };
}

export function demandComplete(status) {
  return {
    type: DEMANDS_COMPLETE,
    payload: status,
  };
}

export function updateInitialStep(step) {
  return {
    type: UPDATE_INITIAL_STEP,
    payload: step,
  };
}

export function setFabricationDetails(fabrication, changeFabricationDate) {
  return {
    type: SET_FABRICATION_DETAILS,
    payload: {
      fabrication,
      changeFabricationDate,
    },
  };
}

export function updateFulfilled(status) {
  return {
    type: UPDATE_FULFILLED,
    payload: status,
  };
}
